<script type="text/jsx">
  export default {
    props: {
      visible: Boolean
    },
    methods: {
      renderCancelBtn () {
        return (
          <el-button className="exit-modal-btn" onClick={() => this.$emit('isVisible', false)}>
            Cancel
          </el-button>
        )
      },
      renderYesBtn () {
        return (
          <el-button class="exit-modal-btn" type="primary" onClick={() => this.$emit('goBack', true)}>
            Yes
          </el-button>
        )
      }
    },
    render () {
      return (
        <el-dialog
          title="Confirm cancellation"
          visible={this.visible}
          size="tiny"
          show-close={false}
          close-on-press-escape={false}
          close-on-click-modal={false}>
          <span>Leaving while the transaction is saving could cause data loss. Do you wish to proceed?</span>
          <span slot="footer" className="dialog-footer">
            {this.renderCancelBtn()}
            {this.renderYesBtn()}
          </span>
        </el-dialog>
      )
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RouteChangeDialog.vue